import { useSelector } from 'APP/Hooks/redux'
import UrlBuilder from 'APP/Helpers/UrlBuilder'
import { useAddDependent } from './provider'

/**
 * Custom hook for managing consent form URL generation.
 *
 * @returns Object containing the generated consent URL
 */
export const useConsentForm = () => {
  const { addDependentForm } = useAddDependent()
  const { firstName, lastName } = addDependentForm.watch()
  const { givenName, familyName } = useSelector((state: any) => state.patient.profile)

  const consentUrl =
    firstName && lastName
      ? UrlBuilder.guardianConsentUrl(givenName, familyName, firstName, lastName)
      : ''

  return { consentUrl }
}
